import api from '../axios';

export const get_customers = async () => {
  try {
    const response = await api.get('/customers');
    return response.data;
  } catch (error) {
    console.error('Error fetching customers:', error);
    return null;
  }
};

export const get_customer_for_link = async () => {
  try {
    const response = await api.get('/customers/link');
    return response.data;
  } catch (error) {
    console.error('Error fetching customers for link:', error);
    return null;
  }
};

export const post_customer = async (data) => {
  try {
    const response = await api.post('/customers', data);
    return response.data;
  } catch (error) {
    console.error('Error creating customer:', error);
    return null;
  }
};

export const update_customer = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.patch(`/customers/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating customer:', error);
    return null;
  }
};

export const delete_customer = async (data) => {
  try {
    const id = data._id || data.id;
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting customer:', error);
    return null;
  }
};

export const sync_customers_records = async (numAccount) => {
  try {
    const body = numAccount ? { num_account: numAccount } : {};
    const response = await api.post('/customers/sync-records', body);
    return response.data;
  } catch (error) {
    console.error('Error syncing customers from records:', error);
    return null;
  }
};
